import { CardContent, Grid, Typography, Stack, Card } from '@mui/material'
import {
  useTranslate,
  useShowContext,
  FunctionField,
  BooleanField,
  ReferenceField,
  useLocaleState,
  CardContentInner,
} from 'react-admin'
import { ShowBase } from '../../components/base'
import { PRODUCTS_COMMON_FIELDS } from '../../providers/localization/constant'
import {
  ContentWrapper,
  Heading,
  PaperStyled,
  PreviewImage,
  TextFieldStyled,
  UrlFieldStyled,
} from '../../components/domains/products'
import { ProductReviewDataList } from '../../components/domains/products-reviews/ProductReviewDataList'

const BrakeDetail = (): JSX.Element => {
  const { record, error, isLoading } = useShowContext()
  const translate = useTranslate()
  const [locale] = useLocaleState()
  const renderProdAxle = (prodAxle): string => {
    if (prodAxle == 'F') {
      return 'หน้า (Front)'
    } else if (prodAxle == 'B') {
      return 'หลัง (Rear)'
    } else if (prodAxle == 'L') {
      return 'ซ้าย (Left)'
    } else if (prodAxle == 'R') {
      return 'ขวา (Right)'
    } else if (prodAxle == null) {
      return '-'
    } else {
      return prodAxle
    }
  }
  return (
    <Grid container spacing={3} sx={{ padding: '16px 16px 0' }}>
      {!isLoading && (
        <>
          <Grid item xs={12} md={12}>
            <Stack spacing={1}>
              <Typography variant='h4' sx={{ color: '#000000' }}>
                {record.product_group_title_th} / {record.product_group_title_en}
              </Typography>
            </Stack>
          </Grid>
          <Grid item sm={12} md={6}>
            <Stack spacing={2}>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_item_status.label`)}</Heading>
                  <FunctionField
                    source='prod_item_status'
                    label={`${PRODUCTS_COMMON_FIELDS}.prod_item_status.label`}
                    render={(record): string => {
                      return record?.prod_item_status !== undefined
                        ? record.prod_item_status === 'N'
                          ? translate(`${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.N`)
                          : translate(`${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.D`)
                        : '-'
                    }}
                    sx={{ color: '#000000', fontWeight: 'normal', fontSize: '1rem' }}
                  />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.mat_group_name.label`)}</Heading>
                  <TextFieldStyled source='mat_group_name' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.mat_group_id.label`)}</Heading>
                  <TextFieldStyled source='mat_group_id' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_name.label`)}</Heading>
                  <TextFieldStyled source='prod_brand_name' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`)}</Heading>
                  <TextFieldStyled source='prod_brand_code' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_model_name.label`)}</Heading>
                  <TextFieldStyled source='prod_model_name' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}</Heading>
                  <TextFieldStyled source='prod_code' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_name_en.label`)}</Heading>
                  <TextFieldStyled source='prod_name_en' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_name_th.label`)}</Heading>
                  <TextFieldStyled source='prod_name_th' emptyText='-' />
                </ContentWrapper>
              </Grid>

              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_axle.label`)}</Heading>
                  <FunctionField
                    source='prod_axle'
                    label={`${PRODUCTS_COMMON_FIELDS}.prod_axle.label`}
                    render={(record): string => {
                      return record?.prod_axle !== undefined
                        ? renderProdAxle(record?.prod_axle)
                        : '-'
                    }}
                    sx={{ color: '#000000', fontWeight: 'normal', fontSize: '1rem' }}
                  />
                </ContentWrapper>
              </Grid>
              <Grid item xs={6}>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_size.label`)}</Heading>
                  <TextFieldStyled source='prod_size' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item xs={6}>
                <ContentWrapper>
                  <Heading>
                    {translate(`${PRODUCTS_COMMON_FIELDS}.prod_size_unit_th.label`)}
                  </Heading>
                  <TextFieldStyled source='prod_size_unit_th' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>
                    {translate(`${PRODUCTS_COMMON_FIELDS}.prod_size_unit_en.label`)}
                  </Heading>
                  <TextFieldStyled source='prod_size_unit_en' emptyText='-' />
                </ContentWrapper>
              </Grid>
            </Stack>
          </Grid>
          <Grid item sm={12} md={6}>
            <Stack spacing={2}>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.sale_price.label`)}</Heading>
                  <TextFieldStyled source='sale_price' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.price_remark.label`)}</Heading>
                  <TextFieldStyled source='price_remark' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>
                    {translate(`${PRODUCTS_COMMON_FIELDS}.promotion_sale_price.label`)}
                  </Heading>
                  <TextFieldStyled source='promotion_sale_price' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.promotion_remark.label`)}</Heading>
                  <TextFieldStyled source='promotion_remark' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>
                    {translate(`${PRODUCTS_COMMON_FIELDS}.green_card_promotion_sale_price.label`)}
                  </Heading>
                  <TextFieldStyled source='green_card_promotion_sale_price' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>
                    {translate(`${PRODUCTS_COMMON_FIELDS}.green_card_promotion_remark.label`)}
                  </Heading>
                  <TextFieldStyled source='green_card_promotion_remark' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>
                    {translate(`${PRODUCTS_COMMON_FIELDS}.ev_card_promotion_sale_price.label`)}
                  </Heading>
                  <TextFieldStyled source='ev_card_promotion_sale_price' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>
                    {translate(`${PRODUCTS_COMMON_FIELDS}.ev_card_promotion_remark.label`)}
                  </Heading>
                  <TextFieldStyled source='ev_card_promotion_remark' emptyText='-' />
                </ContentWrapper>
              </Grid>

              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_desc_en.label`)}</Heading>
                  <TextFieldStyled source='prod_desc_en' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.prod_desc_th.label`)}</Heading>
                  <TextFieldStyled source='prod_desc_th' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.is_active.label`)}</Heading>
                  <FunctionField
                    source='is_active'
                    label={`${PRODUCTS_COMMON_FIELDS}.is_active.label`}
                    render={(record): string => {
                      return record?.is_active !== undefined
                        ? record.is_active
                          ? 'ใช้งาน'
                          : 'ไม่ใช้งาน'
                        : '-'
                    }}
                    sx={{ color: '#000000', fontWeight: 'normal', fontSize: '1rem' }}
                  />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.is_highlight.label`)}</Heading>
                  <BooleanField
                    source='is_highlight'
                    label={`${PRODUCTS_COMMON_FIELDS}.is_highlight.label`}
                  />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.special_flag.label`)}</Heading>
                  <ReferenceField
                    source='special_flag'
                    reference='special-flags'
                    label={`${PRODUCTS_COMMON_FIELDS}.special_flag.label`}
                    emptyText='-'
                  >
                    <TextFieldStyled source={`title_${locale}`}></TextFieldStyled>
                  </ReferenceField>
                </ContentWrapper>
              </Grid>

              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.video_url.label`)}</Heading>
                  <UrlFieldStyled source='video_url' emptyText='-' target='_blank' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.slug_th.label`)}</Heading>
                  <TextFieldStyled source='slug_th' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${PRODUCTS_COMMON_FIELDS}.slug_en.label`)}</Heading>
                  <TextFieldStyled source='slug_en' />
                </ContentWrapper>
              </Grid>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6} sx={{ pt: 3, mb: 3 }} order={{ xs: '0', md: '1' }}>
            {record.image ? (
              <PreviewImage source='image.full_path' />
            ) : (
              <PaperStyled variant='outlined'>
                <Typography variant='caption' sx={{ color: 'error.main' }}>
                  {translate(`${PRODUCTS_COMMON_FIELDS}.image.notfound`)}
                </Typography>
              </PaperStyled>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ pt: 3, mb: 3 }} order={{ xs: '0', md: '1' }}>
            {record.thumbnail ? (
              <PreviewImage source='thumbnail.full_path' />
            ) : (
              <PaperStyled variant='outlined'>
                <Typography variant='caption' sx={{ color: 'error.main' }}>
                  {translate(`${PRODUCTS_COMMON_FIELDS}.thumbnail.notfound`)}
                </Typography>
              </PaperStyled>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ pt: 3, mb: 3 }} order={{ xs: '0', md: '1' }}>
            {record.detail_image ? (
              <PreviewImage source='detail_image.full_path' />
            ) : (
              <PaperStyled variant='outlined'>
                <Typography variant='caption' sx={{ color: 'error.main' }}>
                  {translate(`${PRODUCTS_COMMON_FIELDS}.detail_image.notfound`)}
                </Typography>
              </PaperStyled>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ pt: 3, mb: 3 }} order={{ xs: '0', md: '1' }}>
            {record.warranty_image ? (
              <PreviewImage source='warranty_image.full_path' />
            ) : (
              <PaperStyled variant='outlined'>
                <Typography variant='caption' sx={{ color: 'error.main' }}>
                  {translate(`${PRODUCTS_COMMON_FIELDS}.warranty_image.notfound`)}
                </Typography>
              </PaperStyled>
            )}
          </Grid>
        </>
      )}
      {isLoading && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Loading...</Typography>
          </Grid>
        </Grid>
      )}
      {error && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Error cannot load resource, please contact admin</Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

const BrakeShow = (): JSX.Element => {
  return (
    <ShowBase
      title={`${PRODUCTS_COMMON_FIELDS}.show.title`}
      listAction={{ hasList: false, hasEdit: true, hasBackButton: true }}
      noCard
    >
      <Card>
        <CardContentInner>
          <CardContent>
            <BrakeDetail />
          </CardContent>
        </CardContentInner>
      </Card>
      <ProductReviewDataList />
    </ShowBase>
  )
}

export default BrakeShow
